/// <reference types="@angular/localize" />
/// <reference types="@types/google.maps" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { waitForDomElement } from './app/_helpers/utils';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  Sentry.init({
    dsn: 'https://961952fbd26de206c5f0374222b476ca@o4506773103837184.ingest.us.sentry.io/4506897127833600',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: 1.0, //  Capture 100% of the transactions

    tracePropagationTargets: ['localhost', /^https:\/\/(staging\.)?clients\.lty\.ch/],

    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: environment.name,
  });

  const head = document.getElementsByTagName('head')[0];

  const gtmScript = document.createElement('script');
  gtmScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-619FM8V9ZC';

  const gtmScriptImport = document.createElement('script');
  gtmScriptImport.innerHTML = `(function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-N5PSG6HD');`;

  head.appendChild(gtmScript);
  head.appendChild(gtmScriptImport);

  const gtmNoScript = document.createElement('noscript');
  gtmNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N5PSG6HD" height="0" width="0"
      style="display: none; visibility: hidden"></iframe>`;

  const body = document.getElementsByTagName('body')[0];
  body.appendChild(gtmNoScript);

  // If the app is displayed in webview, we automatically accept the cookie banner
  if (window.isWebview || !!window.ReactNativeWebView) {
    waitForDomElement('.cky-btn-accept').then((e: HTMLElement) => {
      e.click();
    });
  }

  const hotjarScript = document.createElement('script');

  hotjarScript.innerHTML = `(function (c, s, q, u, a, r, e) {
        c.hj=c.hj||function(){(c.hj.q=c.hj.q||[]).push(arguments)};
        c._hjSettings = { hjid: a };
        r = s.getElementsByTagName('head')[0];
        e = s.createElement('script');
        e.async = true;
        e.src = q + c._hjSettings.hjid + u;
        r.appendChild(e);
    })(window, document, 'https://static.hj.contentsquare.net/c/csq-', '.js', 6373831);`;

  const heapScript = document.createElement('script');

  if (environment.staging) {
    heapScript.innerHTML = `
    window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};
    heap.load("2036809914");`;
  } else {
    heapScript.innerHTML = `
    window.heapReadyCb=window.heapReadyCb||[],window.heap=window.heap||[],heap.load=function(e,t){window.heap.envId=e,window.heap.clientConfig=t=t||{},window.heap.clientConfig.shouldFetchServerConfig=!1;var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="https://cdn.us.heap-api.com/config/"+e+"/heap_config.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(a,r);var n=["init","startTracking","stopTracking","track","resetIdentity","identify","getSessionId","getUserId","getIdentity","addUserProperties","addEventProperties","removeEventProperty","clearEventProperties","addAccountProperties","addAdapter","addTransformer","addTransformerFn","onReady","addPageviewProperties","removePageviewProperty","clearPageviewProperties","trackPageview"],i=function(e){return function(){var t=Array.prototype.slice.call(arguments,0);window.heapReadyCb.push({name:e,fn:function(){heap[e]&&heap[e].apply(heap,t)}})}};for(var p=0;p<n.length;p++)heap[n[p]]=i(n[p])};
    heap.load("517968008");`;
  }

  heapScript.type = 'text/javascript';
  head.appendChild(heapScript);

  if (!environment.staging) {
    head.appendChild(hotjarScript);
  }
  if (environment.staging) {
    const noCrawlingMeta = document.createElement('meta');

    noCrawlingMeta.name = 'robots';
    noCrawlingMeta.content = 'noindex, nofollow';
    head.appendChild(noCrawlingMeta);
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
